export const PayrollStatus = {
    Pending: 1,
    Approved: 2,
    Rejected: 3,
    Exported: 4,
};

export const PayrollFlags = {
    ChargeTypeThresholdExceeded: 'Charge type recommended hours exceeded',
    BreakThresholdExceeded: 'Break recommended hours exceeded',
    Overlap: 'Overlap',
    NoPayScheduleOnPWContract: 'No pay schedule on prevailing wage contract',
    NoCountyGroupsOnPWContract: 'No county group on prevailing wage contract',
    DaylightSavingTime: 'Hours were entered during a daylight savings event.',
};

export const TimesheetEmergencyPayTypes = {
    TimeAndAHalf: 1,
    Adjustment: 2,
};

export const PayrollExportCategories = [
    { value: 1, label: 'Standard' },
    { value: 2, label: 'Prevailing Wage' },
    { value: 3, label: 'Special Schedule Rates' },
];
